import AxiosWrapper from "../../basecomp/base/AxiosWrapper";
import { postData } from "../apis/apis";
// impo {axiosPostCall}  from AxiosWrapper;


export const RaiseTicketApi = async (data)=>{
    // alert(data)
    // console.log(data);
    
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/addticket",data)
    // console.log(response);
    let response = await postData("/addticket",data)
    return response
}


export const StoreFilesApi =async (data)=>{
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/addTicketFiles",data)
    try{
    let response = await postData("/addTicketFiles",data)

    return response
    }
    catch(error){
        throw error;
    }
}
// export default RaiseTicketApi